// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/content.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/content.proto.
 */
export const file_console_admin_v1_content: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message console.admin.v1.ContentRelease
 */
export type ContentRelease = Message<"console.admin.v1.ContentRelease"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: console.admin.v1.ContentKind kind = 2;
   */
  kind: ContentKind;

  /**
   * @generated from field: console.admin.v1.ReleaseState state = 3;
   */
  state: ReleaseState;

  /**
   * Staff's own name for a capabilities release; the NHTSA release
   * (`vPICList_lite_2026_09`) for a VIN database build.
   *
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * A capabilities container's versionCode. 0 for a VIN database build.
   *
   * @generated from field: uint64 version_code = 5;
   */
  versionCode: bigint;

  /**
   * The plain file, and the encrypted one.
   *
   * @generated from field: uint64 plain_size_bytes = 6;
   */
  plainSizeBytes: bigint;

  /**
   * @generated from field: string plain_sha256 = 7;
   */
  plainSha256: string;

  /**
   * @generated from field: uint64 size_bytes = 8;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: string created_by_name = 10;
   */
  createdByName: string;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 11;
   */
  publishedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp retired_at = 12;
   */
  retiredAt?: Timestamp | undefined;

  /**
   * @generated from field: string error = 13;
   */
  error: string;

  /**
   * Devices that have fetched its key, and of a capabilities release, devices
   * that report running it.
   *
   * @generated from field: uint32 devices_fetched = 14;
   */
  devicesFetched: number;

  /**
   * @generated from field: uint32 devices_running = 15;
   */
  devicesRunning: number;

  /**
   * For a VIN database build: its VehicleDataBuild.
   *
   * @generated from field: string vehicle_data_build_id = 16;
   */
  vehicleDataBuildId: string;
};

/**
 * Describes the message console.admin.v1.ContentRelease.
 * Use `create(ContentReleaseSchema)` to create a new message.
 */
export const ContentReleaseSchema: GenMessage<ContentRelease> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 0);

/**
 * @generated from message console.admin.v1.ListReleasesRequest
 */
export type ListReleasesRequest = Message<"console.admin.v1.ListReleasesRequest"> & {
  /**
   * @generated from field: console.admin.v1.ContentKind kind = 1;
   */
  kind: ContentKind;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: uint32 offset = 3;
   */
  offset: number;
};

/**
 * Describes the message console.admin.v1.ListReleasesRequest.
 * Use `create(ListReleasesRequestSchema)` to create a new message.
 */
export const ListReleasesRequestSchema: GenMessage<ListReleasesRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 1);

/**
 * @generated from message console.admin.v1.ListReleasesResponse
 */
export type ListReleasesResponse = Message<"console.admin.v1.ListReleasesResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.ContentRelease releases = 1;
   */
  releases: ContentRelease[];

  /**
   * @generated from field: uint32 total = 2;
   */
  total: number;
};

/**
 * Describes the message console.admin.v1.ListReleasesResponse.
 * Use `create(ListReleasesResponseSchema)` to create a new message.
 */
export const ListReleasesResponseSchema: GenMessage<ListReleasesResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 2);

/**
 * @generated from message console.admin.v1.BeginCapabilitiesUploadRequest
 */
export type BeginCapabilitiesUploadRequest = Message<"console.admin.v1.BeginCapabilitiesUploadRequest"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: uint64 version_code = 2;
   */
  versionCode: bigint;

  /**
   * The container as it will be uploaded, which the console checks it
   * against before it is encrypted.
   *
   * @generated from field: uint64 size_bytes = 3;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string sha256 = 4;
   */
  sha256: string;
};

/**
 * Describes the message console.admin.v1.BeginCapabilitiesUploadRequest.
 * Use `create(BeginCapabilitiesUploadRequestSchema)` to create a new message.
 */
export const BeginCapabilitiesUploadRequestSchema: GenMessage<BeginCapabilitiesUploadRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 3);

/**
 * @generated from message console.admin.v1.BeginCapabilitiesUploadResponse
 */
export type BeginCapabilitiesUploadResponse = Message<"console.admin.v1.BeginCapabilitiesUploadResponse"> & {
  /**
   * @generated from field: console.admin.v1.ContentRelease release = 1;
   */
  release?: ContentRelease | undefined;

  /**
   * Every part but the last is exactly this long.
   *
   * @generated from field: uint64 part_bytes = 2;
   */
  partBytes: bigint;

  /**
   * @generated from field: uint32 part_count = 3;
   */
  partCount: number;
};

/**
 * Describes the message console.admin.v1.BeginCapabilitiesUploadResponse.
 * Use `create(BeginCapabilitiesUploadResponseSchema)` to create a new message.
 */
export const BeginCapabilitiesUploadResponseSchema: GenMessage<BeginCapabilitiesUploadResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 4);

/**
 * @generated from message console.admin.v1.CompleteCapabilitiesUploadRequest
 */
export type CompleteCapabilitiesUploadRequest = Message<"console.admin.v1.CompleteCapabilitiesUploadRequest"> & {
  /**
   * @generated from field: string release_id = 1;
   */
  releaseId: string;
};

/**
 * Describes the message console.admin.v1.CompleteCapabilitiesUploadRequest.
 * Use `create(CompleteCapabilitiesUploadRequestSchema)` to create a new message.
 */
export const CompleteCapabilitiesUploadRequestSchema: GenMessage<CompleteCapabilitiesUploadRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 5);

/**
 * @generated from message console.admin.v1.CompleteCapabilitiesUploadResponse
 */
export type CompleteCapabilitiesUploadResponse = Message<"console.admin.v1.CompleteCapabilitiesUploadResponse"> & {
  /**
   * @generated from field: console.admin.v1.ContentRelease release = 1;
   */
  release?: ContentRelease | undefined;
};

/**
 * Describes the message console.admin.v1.CompleteCapabilitiesUploadResponse.
 * Use `create(CompleteCapabilitiesUploadResponseSchema)` to create a new message.
 */
export const CompleteCapabilitiesUploadResponseSchema: GenMessage<CompleteCapabilitiesUploadResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 6);

/**
 * @generated from message console.admin.v1.PublishReleaseRequest
 */
export type PublishReleaseRequest = Message<"console.admin.v1.PublishReleaseRequest"> & {
  /**
   * @generated from field: string release_id = 1;
   */
  releaseId: string;
};

/**
 * Describes the message console.admin.v1.PublishReleaseRequest.
 * Use `create(PublishReleaseRequestSchema)` to create a new message.
 */
export const PublishReleaseRequestSchema: GenMessage<PublishReleaseRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 7);

/**
 * @generated from message console.admin.v1.PublishReleaseResponse
 */
export type PublishReleaseResponse = Message<"console.admin.v1.PublishReleaseResponse"> & {
  /**
   * @generated from field: console.admin.v1.ContentRelease release = 1;
   */
  release?: ContentRelease | undefined;
};

/**
 * Describes the message console.admin.v1.PublishReleaseResponse.
 * Use `create(PublishReleaseResponseSchema)` to create a new message.
 */
export const PublishReleaseResponseSchema: GenMessage<PublishReleaseResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 8);

/**
 * @generated from message console.admin.v1.RetireReleaseRequest
 */
export type RetireReleaseRequest = Message<"console.admin.v1.RetireReleaseRequest"> & {
  /**
   * @generated from field: string release_id = 1;
   */
  releaseId: string;
};

/**
 * Describes the message console.admin.v1.RetireReleaseRequest.
 * Use `create(RetireReleaseRequestSchema)` to create a new message.
 */
export const RetireReleaseRequestSchema: GenMessage<RetireReleaseRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 9);

/**
 * @generated from message console.admin.v1.RetireReleaseResponse
 */
export type RetireReleaseResponse = Message<"console.admin.v1.RetireReleaseResponse"> & {
  /**
   * @generated from field: console.admin.v1.ContentRelease release = 1;
   */
  release?: ContentRelease | undefined;
};

/**
 * Describes the message console.admin.v1.RetireReleaseResponse.
 * Use `create(RetireReleaseResponseSchema)` to create a new message.
 */
export const RetireReleaseResponseSchema: GenMessage<RetireReleaseResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_content, 10);

/**
 * @generated from enum console.admin.v1.ContentKind
 */
export enum ContentKind {
  /**
   * @generated from enum value: CONTENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTENT_KIND_VEHICLE_DATA = 1;
   */
  VEHICLE_DATA = 1,

  /**
   * @generated from enum value: CONTENT_KIND_CAPABILITIES = 2;
   */
  CAPABILITIES = 2,
}

/**
 * Describes the enum console.admin.v1.ContentKind.
 */
export const ContentKindSchema: GenEnum<ContentKind> = /*@__PURE__*/
  enumDesc(file_console_admin_v1_content, 0);

/**
 * @generated from enum console.admin.v1.ReleaseState
 */
export enum ReleaseState {
  /**
   * @generated from enum value: RELEASE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Parts are going up.
   *
   * @generated from enum value: RELEASE_STATE_UPLOADING = 1;
   */
  UPLOADING = 1,

  /**
   * Being checked and encrypted.
   *
   * @generated from enum value: RELEASE_STATE_SEALING = 2;
   */
  SEALING = 2,

  /**
   * Encrypted and stored; not offered.
   *
   * @generated from enum value: RELEASE_STATE_READY = 3;
   */
  READY = 3,

  /**
   * Offered to tablets.
   *
   * @generated from enum value: RELEASE_STATE_PUBLISHED = 4;
   */
  PUBLISHED = 4,

  /**
   * Key and file deleted.
   *
   * @generated from enum value: RELEASE_STATE_RETIRED = 5;
   */
  RETIRED = 5,

  /**
   * The upload or the encryption failed; `error` says why.
   *
   * @generated from enum value: RELEASE_STATE_FAILED = 6;
   */
  FAILED = 6,
}

/**
 * Describes the enum console.admin.v1.ReleaseState.
 */
export const ReleaseStateSchema: GenEnum<ReleaseState> = /*@__PURE__*/
  enumDesc(file_console_admin_v1_content, 1);

/**
 * Encrypted releases (ARCHITECTURE.md §15.6): the files the console serves
 * tablets encrypted, each under a key of its own that only comes through the
 * mutual TLS gateway. VIN decoding database builds become releases on their
 * own as they are built (VehicleDataService); capabilities containers are
 * uploaded by staff here. Staff only. Read-only staff may call the List
 * call; the rest need the Fulfillment role.
 *
 * @generated from service console.admin.v1.ContentService
 */
export const ContentService: GenService<{
  /**
   * Releases of one kind, newest first.
   *
   * @generated from rpc console.admin.v1.ContentService.ListReleases
   */
  listReleases: {
    methodKind: "unary";
    input: typeof ListReleasesRequestSchema;
    output: typeof ListReleasesResponseSchema;
  },
  /**
   * Start uploading a capabilities container. The file then goes up in parts,
   * each a PUT of exactly `part_bytes` (the last one shorter) to
   * `/staff/content/releases/<release_id>/parts/<n>` from 1, with the console
   * session and the `connect-protocol-version` header. Audited as
   * `content.release_created`.
   *
   * @generated from rpc console.admin.v1.ContentService.BeginCapabilitiesUpload
   */
  beginCapabilitiesUpload: {
    methodKind: "unary";
    input: typeof BeginCapabilitiesUploadRequestSchema;
    output: typeof BeginCapabilitiesUploadResponseSchema;
  },
  /**
   * Every part is up: the console checks the file against the size and
   * sha256 given at the start, encrypts it under a new key, and keeps only
   * the encrypted file. The release is `sealing`, then `ready` (or `failed`,
   * with the reason).
   *
   * @generated from rpc console.admin.v1.ContentService.CompleteCapabilitiesUpload
   */
  completeCapabilitiesUpload: {
    methodKind: "unary";
    input: typeof CompleteCapabilitiesUploadRequestSchema;
    output: typeof CompleteCapabilitiesUploadResponseSchema;
  },
  /**
   * Offer a `ready` capabilities release to tablets in place of the one offered
   * now, which stays `ready` and can be published again. Audited as
   * `content.release_published`.
   *
   * @generated from rpc console.admin.v1.ContentService.PublishRelease
   */
  publishRelease: {
    methodKind: "unary";
    input: typeof PublishReleaseRequestSchema;
    output: typeof PublishReleaseResponseSchema;
  },
  /**
   * Take a release out of use for good: its key is deleted from the key
   * store and its file from storage, so no copy of it anywhere can be opened
   * again. Refused for the release being offered. Audited as
   * `content.release_retired`.
   *
   * @generated from rpc console.admin.v1.ContentService.RetireRelease
   */
  retireRelease: {
    methodKind: "unary";
    input: typeof RetireReleaseRequestSchema;
    output: typeof RetireReleaseResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_content, 0);

